import { render, staticRenderFns } from "./TokenWithdrawalConfirm.vue?vue&type=template&id=ac8c2f6c&"
import script from "./TokenWithdrawalConfirm.vue?vue&type=script&lang=js&"
export * from "./TokenWithdrawalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports